export const error = '#A8200D';
export const errorBackground = '#FDEBE9';
export const white = '#FFFFFF';
